module.exports = __webpack_public_path__ + "img/11.79933be9.svg";